import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-paint-bucket" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Theme ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Unlock Theme ")
const _hoisted_4 = { class: "au-theme-list__item-name flex-centered mb3 mt2" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "au-theme-menu__list-wrapper" }
const _hoisted_8 = { class: "au-theme-list" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "au-theme-list__item-bg" }, null, -1)
const _hoisted_11 = { class: "au-theme-list__item-content" }
const _hoisted_12 = { class: "flex-space-between col-12" }
const _hoisted_13 = { class: "flex-centered" }
const _hoisted_14 = { class: "au-theme-list__item-label" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Back to Menu ")

import { computed, reactive } from 'vue';
    import NavigableScreen from 'components/navigable-screen.vue';
    import NavButton from 'components/nav-button.vue';
    import Card from 'components/card.vue';
    import Modal from 'components/modal.vue';
    import CreditsBadge from 'components/credits-badge.vue';
    import { Theme, Themes, HEX, ThemeKey } from 'src/themes-v2';
    import { useModule } from 'src/modules/modules';

    interface ThemeItem {
        key: ThemeKey,
        name: string,
        class: string,
        palette: HEX[],
        credits: number,
        unlocked: boolean
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'theme-menu',
  emits: ['back'],
  setup(__props, { emit }) {

_useCssVars(_ctx => ({
  "51d547e6": (_unref(themeStore).theme.titleBg),
  "c1ad23b6": (_unref(themeStore).theme.cardBg)
}))

    const { theme: themeStore , achievements, global, audio } = useModule();
    
    const modal = reactive<{ 
        visible: boolean,  
        unlockable: boolean,
        target: null | (Theme & { key: ThemeKey }) 
    }>({
        visible: false,
        unlockable: false,
        target: null
    })

    /**
     * Internal theme item schema item as used by `themesComputed` to simplify template
     */
    const handleThemeSelected = (key: ThemeKey) => {
        audio.play('FX_menu_btn');
        if (achievements.isThemeUnlocked(key)){
            if (!global.reduceFlashing){
                global.sceneState.scene?.cameras.main.flash(500);
            } 

            themeStore.setTheme(key);
            return;
        }

        let theme = Themes[key];
        modal.visible = true;
        modal.target = {
            ...theme,
            key: key
        };

        modal.unlockable = modal.target?.credits ? achievements.getCredits() >= modal.target?.credits : true;
    }

    const handleCancelUnlock = () => modal.visible = false;
    const handleModalHidden = () => modal.target = null;
    const handleUnlock = () => {
        if (modal.target?.credits && achievements.getCredits() >= modal.target?.credits){
            achievements.unlockTheme(modal.target.key);
            themeStore.setTheme(modal.target.key);
            modal.target = null;
            modal.visible = false;

            //TODO: Play sound or something also
            if (!global.reduceFlashing){
                global.sceneState.scene?.cameras.main.flash(500);
            } 
        }
    }
    
    const handleNativeBack = () => {
        if (!modal.visible){
            emit('back');
        }
    }

    /**
     * Generates a `ThemeItem` object w/ all the necessary information to easily render in template,
     * including achievement unlock status and classes.
     */
    const themesComputed = computed<ThemeItem[]>(() => {
        return Object.entries(Themes).map(entry => {
            let themeKey = <ThemeKey> entry[0], theme = entry[1];
            let unlocked =  achievements.isThemeUnlocked(themeKey)

            let c = 'au-theme-list__item';
            if (themeStore.themeKey === themeKey) c += ' au-theme-list__item--selected';
            if (!unlocked) c += ' au-theme-list__item--locked';

            return <ThemeItem> {
                key: themeKey,
                name: theme.name,
                class: c,
                palette: theme.palette,
                credits: theme.credits ?? 0,
                unlocked: unlocked
            }
        })

    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NavigableScreen, {
    "use-banner-offset": "",
    onNativeBack: handleNativeBack
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    content: _withCtx(() => [
      _createVNode(Modal, {
        visible: modal.visible,
        onCancel: handleCancelUnlock,
        onSubmit: handleUnlock,
        onHidden: handleModalHidden,
        "submit-label": "Unlock",
        "hide-submit": !modal.unlockable,
        "cancel-label": modal.unlockable ? 'No Thanks' : 'Ok',
        "close-on-android-back": ""
      }, {
        title: _withCtx(() => [
          _hoisted_3
        ]),
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "au-theme-list__item-preview",
              style: _normalizeStyle({ background: modal.target?.palette[0] ?? '#ffffff' 
                        })
            }, null, 4),
            _createTextVNode(" " + _toDisplayString(modal.target?.name), 1)
          ]),
          (modal.unlockable)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Unlock this theme for " + _toDisplayString(modal.target?.credits) + " credits? ", 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_6, " You'll need " + _toDisplayString((modal.target?.credits ?? 0) - _unref(achievements).getCredits()) + " more credits to unlock this theme. You can earn credits simply by playing or by completing achievements! ", 1))
        ]),
        _: 1
      }, 8, ["visible", "hide-submit", "cancel-label"]),
      _createVNode(_Transition, {
        name: "slide-fade",
        appear: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(themesComputed), (theme) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: theme.key,
                  class: _normalizeClass(theme.class),
                  onClick: () => handleThemeSelected(theme.key)
                }, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", {
                          class: "au-theme-list__item-preview",
                          style: _normalizeStyle({ background: theme.palette[0] ?? '#ffffff' })
                        }, null, 4),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(theme.name), 1)
                      ]),
                      _hoisted_15
                    ])
                  ])
                ], 10, _hoisted_9))
              }), 128))
            ])
          ])
        ]),
        _: 1
      })
    ]),
    "nav-center": _withCtx(() => [
      _createVNode(NavButton, {
        type: "back",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('back')))
      }, {
        default: _withCtx(() => [
          _hoisted_16
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})